import React from 'react';
import {
  ISchemaDataModelFieldsFragment,
  ITableColumnFieldsFragment,
} from '../../../../utils/apollo/graphqlSchema';
import { useDimensionOptionalFieldsModel } from './dimensionUtils';
import DataModelerSubjectsSection from './DataModelerSubjectsSection';
import DataModelerInstallTemporalsSection from './DataModelerInstallTemporalsSection';

interface IProps {
  schemaObj: ISchemaDataModelFieldsFragment;
  isEditMode: boolean;
  viewKey: string;
  tableKey: string;
  availableColumnsFromServer: ITableColumnFieldsFragment[];
}

const DataModelerOptionalDimensionFields = ({
  schemaObj,
  isEditMode,
  tableKey,
  viewKey,
  availableColumnsFromServer,
}: IProps) => {
  const {
    subjectRequired,
    subjectsList,
    addNewSubject,
    removeNewSubject,
    suggestedNextSubjectName,
    updateSubjectColumn,
    subjectNameValidatorFunc,
    updateSubjectName,
    installTemporalsCanEdit,
    installTemporalsData,
    installTemporalsCanInit,
    installTemporalsInit,
    installTemporalsRemove,
    installTemporalsSetDate,
  } = useDimensionOptionalFieldsModel({
    schemaObj,
    isEditMode,
    viewKey,
    tableKey,
  });
  return (
    <>
      <DataModelerSubjectsSection
        key={`edit-subjects-${subjectsList.length}`}
        isEditMode={isEditMode}
        schemaObj={schemaObj}
        tableKey={tableKey}
        availableColumnsFromServer={availableColumnsFromServer}
        subjectRequired={subjectRequired}
        subjectsList={subjectsList}
        addNewSubject={addNewSubject}
        removeNewSubject={removeNewSubject}
        updateSubjectColumn={updateSubjectColumn}
        subjectNameValidatorFunc={subjectNameValidatorFunc}
        suggestedNextSubjectName={suggestedNextSubjectName}
        updateSubjectName={updateSubjectName}
      />
      <DataModelerInstallTemporalsSection
        schemaObj={schemaObj}
        tableKey={tableKey}
        availableColumnsFromServer={availableColumnsFromServer}
        temporalsData={installTemporalsData}
        canEdit={installTemporalsCanEdit}
        canInit={installTemporalsCanInit}
        canRemove={installTemporalsCanEdit}
        initInstallTemporals={installTemporalsInit}
        removeInstallTemporals={installTemporalsRemove}
        setInstallDate={installTemporalsSetDate}
        eventDateColumn={null}
      />
    </>
  );
};

export default DataModelerOptionalDimensionFields;
